/* eslint-disable eqeqeq */
import React from 'react'

import { useTranslation } from 'react-i18next'
import BPMBasicPage from '../../../components/BPMTable/PagesCreator/BPMBasicPage'
import CMInventoryChangeTableCreator from '../../../tableDefinitions/Jobs/companyManagement/CMInventoryChangeTableCreator'

function CMSubmissions(props){
    const { t } = useTranslation(['CMSubmissions'])
    document.title = `${t('Integration Submissions')} - BubbleBPM`

    return (
        <BPMBasicPage
            tableName={'Integration Submissions'}
            tableCreatorCreatorId={CMInventoryChangeTableCreator.getId()}
            path={props.match.url}
        />
    )
}

export default CMSubmissions

